import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import LogRocket from 'logrocket';

import { config } from './config';

const initErrorReporting = () => {
  if (process.env.NODE_ENV === 'production') {
    LogRocket.init(config.logrocket.appId);

    Sentry.init({
      dsn: config.sentry.dsn,
      integrations: [new Integrations.BrowserTracing()],
      environment: process.env.NODE_ENV,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
      beforeSend(event) {
        const logRocketSession = LogRocket.sessionURL;
        if (logRocketSession !== null && event.extra) {
          event.extra.LogRocket = logRocketSession;
          return event;
        } else {
          return event;
        }
      },
    });
  }
};

export { initErrorReporting };
